/* tslint:disable */

export const faYandexInternational: any = {"prefix":"fab","iconName":"yandex-international","icon":[320,512,[],"f414","M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"]};